import { useState, useEffect } from 'react';

export function useInstallPrompt() {
  // index.html에서 이미 캡처된 이벤트가 있으면 초기값으로 사용
  const [deferredPrompt, setDeferredPrompt] = useState(window.deferredInstallPrompt || null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // standalone 모드 감지 (이미 설치됨)
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      setIsInstalled(true);
      return;
    }

    // iOS 감지
    setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent));

    // 이후 발생하는 beforeinstallprompt도 캡처
    const handler = (e) => {
      e.preventDefault();
      window.deferredInstallPrompt = e;
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // head에서 캡처된 이벤트를 React에 전달하는 커스텀 이벤트 수신
    const pwaHandler = () => {
      if (window.deferredInstallPrompt) {
        setDeferredPrompt(window.deferredInstallPrompt);
      }
    };
    window.addEventListener('pwa-install-available', pwaHandler);

    const installedHandler = () => {
      setIsInstalled(true);
      setDeferredPrompt(null);
      window.deferredInstallPrompt = null;
    };
    window.addEventListener('appinstalled', installedHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('appinstalled', installedHandler);
      window.removeEventListener('pwa-install-available', pwaHandler);
    };
  }, []);

  const promptInstall = async () => {
    const prompt = deferredPrompt || window.deferredInstallPrompt;
    if (!prompt) return false;
    const result = await prompt.prompt();
    setDeferredPrompt(null);
    window.deferredInstallPrompt = null;
    return result.outcome === 'accepted';
  };

  return { isInstalled, isIOS, canInstall: !!(deferredPrompt || window.deferredInstallPrompt), promptInstall };
}
